import { render, staticRenderFns } from "./OpenCourseShare.vue?vue&type=template&id=72a04db8&scoped=true&"
import script from "./OpenCourseShare.vue?vue&type=script&lang=js&"
export * from "./OpenCourseShare.vue?vue&type=script&lang=js&"
import style0 from "./OpenCourseShare.vue?vue&type=style&index=0&id=72a04db8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a04db8",
  null
  
)

export default component.exports